if(!customElements.get('featured-products')) {
  class ComponentFeaturedProducts extends HTMLElement {
    constructor() {
      super();
      this.sliderElement = this.querySelector('.keen-slider.main-carousel');

      this.carouselMode = this.dataset.carouselMode;
      this.carouselLoop = this.dataset.carouselLoop;
      this.carouselAutoplay = this.dataset.carouselAutoplay;
      this.carouselCenteredDesktop = this.dataset.carouselCenteredDesktop;
      this.carouselSpacingDesktop = this.dataset.carouselSpacingDesktop;
      this.slidesPerViewDesktop = this.dataset.slidesPerViewDesktop;
      this.carouselCenteredTablet = this.dataset.carouselCenteredTablet;
      this.carouselSpacingTablet = this.dataset.carouselSpacingTablet;
      this.slidesPerViewTablet = this.dataset.slidesPerViewTablet;
      this.carouselCenteredMobile = this.dataset.carouselCenteredMobile;
      this.carouselSpacingMobile = this.dataset.carouselSpacingMobile;
      this.slidesPerViewMobile = this.dataset.slidesPerViewMobile;

      setTimeout(()=>{ //The timeout is for the customizer
        this.initSlider();
      }, 1);
    }

    initSlider() {
      var config = {
        mode: this.carouselMode,
        loop: this.carouselLoop=="true",
        prevButton: this.querySelector('.keen-arrow.prev'),
        nextButton: this.querySelector('.keen-arrow.next'),
        autoplay: this.carouselAutoplay,
        slides: '.main-carousel > .keen-slider-slide',
        breakpoints: {
          '(min-width: 901px)': {
            centered: this.carouselCenteredDesktop=="true",
            spacing: this.carouselSpacingDesktop,
            slidesPerView: this.slidesPerViewDesktop
          },
          '(min-width: 601px) and (max-width: 900px)': {
            centered: this.carouselCenteredTablet=="true",
            spacing: this.carouselSpacingTablet,
            slidesPerView: this.slidesPerViewTablet
          },
          '(max-width: 600px)': {
            centered: this.carouselCenteredMobile=="true",
            spacing: this.carouselSpacingMobile,
            slidesPerView: this.slidesPerViewMobile
          }
        }
      }
      var dots = this.querySelector('.main-carousel > .keen-dots');
      if (dots) {
        config = {...config, dots: dots};
      } else {
        var band = this.querySelector('.keen-nav-bar');
        config = {...config, navBar: band, rubberband: false};
      }
      this.sliderObj = new KeenSlider(this.sliderElement, config);
    }
  }
  customElements.define('featured-products', ComponentFeaturedProducts);
}